import { makeAssistantDataUI, useAuiState } from '@assistant-ui/react';
import type { CitationRef } from '@iq/contracts/v1/chat';
import { useEffect } from 'react';
import { useCitationStore } from './citation-store';

interface CitationsPayload {
  citations: CitationRef[];
}

/**
 * Renderer for `data-citations` parts streamed by the backend after the LLM
 * finishes generating. Pushes the citations into the shared store keyed by
 * the current assistant message id; returns `null` so nothing is painted in
 * the message body.
 *
 * Mount once inside the `AssistantRuntimeProvider` subtree so assistant-ui's
 * data-UI registry picks it up.
 */
export const CitationDataUI = makeAssistantDataUI<CitationsPayload>({
  name: 'citations',
  render: ({ data }) => {
    const messageId = useAuiState((s) => s.message.id);
    const { setMessage } = useCitationStore();
    useEffect(() => {
      if (messageId && Array.isArray(data?.citations)) {
        setMessage(messageId, data.citations);
      }
    }, [messageId, data, setMessage]);
    return null;
  },
});
